import posthog from 'posthog-js';

// Only initialize PostHog if the key is present (for production environments)
if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: '/ingest',
    ui_host: 'https://us.posthog.com',
    // Include the defaults option as required by PostHog
    defaults: '2025-05-24',
    // Enables capturing unhandled exceptions via Error Tracking
    capture_exceptions: true,
    // Debug mode disabled to reduce console noise
    debug: false,
  });
} else {
  // PostHog is disabled in this environment
  console.log('PostHog analytics disabled (no API key configured)');
}
